<template>
    <preview

        ref="preview"
        :width="width"
        :height="height"
        :can-cancel-preview-generation="false"
        :creation-request-params="creationRequestParams"
        :has-custom-preview-step="true"
        :default-image="defaultImage"
    >
        <template v-slot:customPreview="customPreview">
            <VideoPreview
                :width="width"
                :height="height"
                :generated-preview="customPreview.preview"
                :extended-preview="extendedPreview"
                :channel="channel"
                :configuration="configuration"
                @previewStopped="previewStopped"
                @previewOver="previewOver"
                @setPreview="setPreview"
            ></VideoPreview>
        </template>
    </preview>
</template>

<script>
import VideoPreview from './video-preview.vue';
import Preview from '@/components/Preview';
export default {
    name:'ChannelAndConfigurationPreview',
    components:{
        VideoPreview,
        Preview
    },
    props:{
        channel:{
            type: Object,
            default: null,
        },
        configuration:{
            type: Object,
            default: null,
        },
        width:{
            type: Number,
        },
        height:{
            type: Number,
        },
        defaultImage:{
            type: String,
            default: ''
        }
    },
    data(){
        return{
            extendedPreview: null,
        };
    },
    computed :{
        creationRequestParams(){
            let params =  {
                context: this.channel?{channel_uid: this.channel.uid}: {configuration_uid: this.configuration.uid},
                model: 'previewCreationRequest',
                url: this.$store.state.api.meta.listModels.previewCreationRequest.url,
                scopes : this.channel?{'X-Entity-Uid': this.channel.scopes.entity_uid}:{'X-Entity-Uid': this.configuration.scopes.entity_uid}
            };
            return params;
        }
    },
    methods:{
        toggleSound() {
            this.unmuted = !this.unmuted;
        },
        previewStopped(){
            this.$refs.preview.changeStep(0)
        },
        previewOver(){
            this.$refs.preview.changeStep(0)
        },
        setPreview(preview){
            this.extendedPreview = preview;
        }
    }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/ChannelAndConfigurationPreview/index.vue